import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyD8D4xK-rDjmiX3wuYav7Ci6l0L1VWpUGU",
  authDomain: "schreibtischkeil.firebaseapp.com",
  projectId: "schreibtischkeil",
  storageBucket: "schreibtischkeil.firebasestorage.app",
  messagingSenderId: "182154845254",
  appId: "1:182154845254:web:fd56c690750cf26e68be47",
  measurementId: "G-HH3PMW938P"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
